import { AgResourceLanguage } from '../types';

export const commonContent: AgResourceLanguage['commonContent'] = {
  orderBodyContent: {
    nextOnlyLabel: 'Einmalig',
    outOfStockLabel: 'Nicht vorrätig',
    quantityLabel: 'Anzahl:',
    productHiddenLabel: 'Produkte',
    productsSubtitle: 'Produkte',
    subscriptionTitle: 'Subscription',
    otpTitle: 'This order only'
  },
  referFriendCard: {
    title: 'Freund:innen werben',
    text: `Sie erhalten ein kostenloses AG1-Monatspaket, sobald sie ein Abo abschließen.`
  },
  slider: {
    empty: {
      title: 'Unsere Abos'
    },
    notEmpty: {
      title: 'Der AG1 Shop',
      description: 'Exklusiv für AG1 Member'
    },
    cardContent: {
      addToSubscription: 'Zahlungspflichtig abonnieren',
      addedToSubscription: 'Zur nächsten Abonnement hinzufügen',
      addToNextOrder: 'Einmalig zahlungspflichtig bestellen',
      addedToNextOrder: 'Zur nächsten Bestellung hinzugefügt',
      maxQuantityReached: 'Maximale Menge erreicht'
    }
  },
  buttons: {
    subscribeAndSave: 'Abonnieren und speichern',
    subscribe: 'Abonnieren',
    delete: 'Löschen'
  },
  status: {
    fulfilled: 'Abgeschlossen',
    partial: 'Partially fulfilled',
    paid: 'Versand in Bearbeitung',
    refunded: 'Refunded',
    partially: 'Partially refunded',
    unpaid: 'Unbezahlt'
  },
  statusV2: {
    Unfulfilled: 'Vorbereitung',
    Fulfilled: 'Versand',
    'On hold': 'Vorbereitung'
  }
};
